/// <amd-module name="TFS/Security/Common/Members/DataSource/SecurityMembersDataSource" />
import { ISecurityMembersData } from "TFS/Security/Common/Members/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const securityMembersDataProvider = "ms.vss-admin-web.security-view-members-data-provider";
const securityViewUpdateDataProvider = "ms.vss-admin-web.security-view-update-data-provider";

export function getResourcesSecurityMembers(
    pageContext: IVssPageContext,
    permissionSetId: string,
    permissionSetToken: string
): Promise<ISecurityMembersData | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    return contributionService
        .getDataAsync<ISecurityMembersData>(
            securityMembersDataProvider,
            { permissionSetId: permissionSetId, permissionSetToken: permissionSetToken },
            true
        )
        .then(result => {
            return result;
        });
}

export function updateSecurityInheritPermissions(
    pageContext: IVssPageContext,
    permissionSetId: string,
    permissionSetToken: string,
    inheritPermissions: boolean
): Promise<any> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    return contributionService
        .getDataAsync<any>(
            securityViewUpdateDataProvider,
            {
                changeInheritance: true,
                permissionSetId: permissionSetId,
                permissionSetToken: permissionSetToken,
                inheritPermissions: inheritPermissions
            },
            true
        )
        .then(result => {
            return result;
        });
}
